module.exports = __webpack_public_path__ + "static/img/LOGO_ISO_2.c632f93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LOGO_ISO_2.png
// module id = XDWZ
// module chunks = 36